module.exports = __webpack_public_path__ + "static/media/iconeSequencial.b6c42e82.svg";